/**
 * Utility functions for packaging-related operations
 */

import { capitalizeWords } from './regex';
import type { PartnerDimWeightDiscountFactor, PartnerPackagingV2 } from '@shipium-corp/shipium-ts-types';

export const PACKAGING_MATERIALS: PartnerDimWeightDiscountFactor['packagingMaterial'][] = [
  'box',
  'envelope',
  'flat_pack',
  'mailing_tube',
  'parcel_pallet',
  'soft_pack',
  'fedex_one_rate_envelope',
  'fedex_one_rate_extra_large_box',
  'fedex_one_rate_large_box',
  'fedex_one_rate_medium_box',
  'fedex_one_rate_pak',
  'fedex_one_rate_small_box',
  'fedex_one_rate_tube',
  'usps_large_box',
  'usps_large_box_to_apo_fpo_dpo',
  'usps_medium_box',
  'usps_small_box',
  'usps_legal_envelope',
  'usps_envelope',
  'usps_padded_envelope',
  'ups_express_envelope',
];

const nameMap: Record<string, string> = {
  // FedEx One Rate
  fedex_one_rate_envelope: 'FedEx OneRate® - Fedex® Envelope',
  fedex_one_rate_pak: 'FedEx OneRate® - Fedex® Pak',
  fedex_one_rate_small_box: 'FedEx OneRate® - Fedex® Small Box',
  fedex_one_rate_medium_box: 'FedEx OneRate® - Fedex® Medium Box',
  fedex_one_rate_large_box: 'FedEx OneRate® - Fedex® Large Box',
  fedex_one_rate_extra_large_box: 'FedEx OneRate® - Fedex® Extra Large Box',
  fedex_one_rate_tube: 'FedEx OneRate® - Fedex® Tube',

  // USPS Flat Rate & Priority Mail
  usps_small_box: 'USPS Priority Mail Small Flat Rate Box',
  usps_medium_box: 'USPS Priority Mail Medium Flat Rate Box',
  usps_large_box: 'USPS Priority Mail Large Flat Rate Box',
  usps_large_box_to_apo_fpo_dpo: 'USPS Large Flat Rate Box (APO/FPO/DPO)',
  usps_legal_envelope: 'USPS Legal Flat Rate Envelope',
  usps_envelope: 'USPS Flat Rate Envelope',
  usps_padded_envelope: 'USPS Padded Flat Rate Envelope',

  // UPS Express
  ups_express_envelope: 'UPS Express Envelope',
};

/**
 * Formats packaging size names to human-readable labels
 * @param packagingSizeName - The internal packaging size name
 * @returns Formatted display name
 */
export const formatPackagingName = (packagingSizeName: PartnerPackagingV2['packagingSizeName']): string => {
  return nameMap[packagingSizeName] || capitalizeWords(packagingSizeName.replaceAll('_', ' '));
};
